import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/Home.vue')
    },
    {// products
      path: '/product/ip-transit',
      name: 'IPTransit',
      component: () => import('@/views/products/IPTransit.vue')
    },
    {
      path: '/product/bare-metal',
      name: 'BareMetal',
      component: () => import('@/views/products/BareMetal.vue')
    },
    {
      path: '/product/cloud-vm',
      name: 'CloudVM',
      component: () => import('@/views/products/CloudVM.vue')
    },
    {
      path: '/product/sdwan',
      name: 'SDWAN',
      component: () => import('@/views/products/SDWAN.vue')
    },
    {// network
      path: '/network/global-network',
      name: 'GlobalNetwork',
      component: () => import('@/views/network/GlobalNetwork.vue')
    },
    {
      path: '/network/locations',
      name: 'Locations',
      component: () => import('@/views/network/Locations.vue')
    },
    {
      path: '/network/latency',
      name: 'Latency',
      component: () => import('@/views/network/Latency.vue')
    },
    {
      path: '/network/ddos-shield',
      name: 'DDoSShield',
      component: () => import('@/views/network/DDoSShield.vue')
    },
    {// company
      path: '/company/about',
      name: 'About',
      component: () => import('@/views/company/About.vue')
    },
    {
      path: '/company/careers',
      name: 'Careers',
      component: () => import('@/views/company/Careers.vue')
    },
    {// pricing
      path: '/pricing',
      name: 'Pricing',
      component: () => import('@/views/Pricing.vue')
    },
    {// terms
      path: '/terms/Service',
      name: 'Service',
      component: () => import('@/views/terms/Service.vue')
    }
  ]
})

export default router 